module.exports = __webpack_public_path__ + "images/backgrounds/purty_wood_dark.2bb7ffbf9b244b836f0e.png";